<template>
    <section class="login-hero is-fullheight">
        <div class="login-wrap">
            <div class="login-card box">
                <img class="logo" :src="logoSrc" alt="logo">
                <h1 class="title is-3 has-text-centered">Bienvenido de nuevo</h1>
                <p class="login-sub">Ingresa tus credenciales para continuar</p>

                <b-field label="Usuario">
                    <b-input
                        icon="shield-account"
                        type="text"
                        placeholder="Escribe tu nombre de usuario"
                        v-model="usuario.usuario"
                    ></b-input>
                </b-field>

                <b-field label="Contraseña">
                    <b-input
                        :key="showPassword"
                        :type="showPassword ? 'text' : 'password'"
                        placeholder="Escribe tu contraseña"
                        v-model="usuario.password"
                        icon-right="eye"
                        @click-icon-right="showPassword = !showPassword"
                    ></b-input>
                </b-field>

                <b-field>
                    <b-checkbox v-model="showPassword">Mostrar contraseña</b-checkbox>
                </b-field>

                <div class="buttons is-centered">
                    <b-button class="login-btn" @click="iniciarSesion">Entrar</b-button>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import HttpService from '../../Servicios/HttpService'
    import AyudanteSesion from '../../Servicios/AyudanteSesion'

    export default {
        name: "InicioSesion",
        
        data:()=>({
            usuario: {
                usuario: "",
                password: ""
            },

            informacionNegocio: null,
            showPassword: false
        }),

        mounted(){
            // Limpiar token antiguo que podría interferir con el inicio de sesión
            localStorage.removeItem('token')
            this.obtenerInformacionLocal()
            this.informacionNegocio = AyudanteSesion.obtenerDatosNegocio()
        },

        computed: {
            logoSrc(){
                const apiBase = this.apiBase
                const datos = this.informacionNegocio || AyudanteSesion.obtenerDatosNegocio()
                if(datos && datos.logo){
                    const logo = datos.logo
                    if(typeof logo !== 'string') return require('@/assets/logo.png')
                    if(logo.startsWith('data:')) return logo
                    if(logo.startsWith('http')) return logo
                    // normalizar rutas devueltas por la API
                    const origin = window.location.origin
                    if(logo.startsWith('/api')) return `${origin}${logo}`
                    if(logo.startsWith('api/')) return `${origin}/${logo}`
                    if(logo.startsWith('/logos')) return `${apiBase}${logo.replace(/^\//, '')}`
                    if(logo.indexOf('logos') !== -1) return `${apiBase}${logo.replace(/^\//, '')}`
                    // por defecto asumir filename
                    return `${apiBase}logos/${logo}`
                }
                return require('@/assets/logo.png')
            },
            apiBase(){
                const host = (window.location.hostname || '').toLowerCase()
                const protocol = window.location.protocol || 'http:'
                const origin = window.location.origin
                if(host === 'localhost' || host === '127.0.0.1' || host === '::1'){
                    return `${protocol}//${host}/grupos_lldm/api/`
                }
                return `${origin}/grupos_lldm/api/`
            }
        },

        methods:{
            iniciarSesion(){
                let payload = {
                    accion: 'iniciar_sesion',
                    usuario: this.usuario
                }

                HttpService.obtenerConConsultas('usuarios.php', payload)
                .then(resultado => {
                    if(!resultado || typeof resultado !== 'object'){
                        this.$buefy.toast.open({
                          type: 'is-danger',
                          message: 'Información incorrecta. Verifica.'
                        })
                        return
                    }

                    if(resultado.estado){
                        // guardar sesión (token, roles, id, nombre) en localStorage
                        const usuarioSesion = Object.assign({}, resultado.usuario || {});
                        if(resultado.token) usuarioSesion.token = resultado.token;
                        AyudanteSesion.establecerSesion(usuarioSesion);

                        this.$buefy.toast.open({
                            type: 'is-info',
                            message: 'Información correcta. Bienvenido.'
                        })
                        this.$router.push({ name: 'InicioComponent' })
                        this.$emit("login", resultado)
                        return
                    }

                    this.$buefy.toast.open({
                      type: 'is-danger',
                      message: (resultado && resultado.mensaje) ? resultado.mensaje : 'No se pudo iniciar sesión.'
                    })
                })
                .catch(() => {
                    this.$buefy.toast.open({
                      type: 'is-danger',
                      message: 'Error de conexión con el servidor.'
                    })
                })
            },

            obtenerInformacionLocal(){
                HttpService.obtenerConConsultas('ajustes.php',{
                    accion: 'obtener'
                })
                .then(resultado =>{
                    AyudanteSesion.establecerDatosNegocio(resultado)
                    this.informacionNegocio = AyudanteSesion.obtenerDatosNegocio()
                })
            }
        }
        
    }
</script>

<style scoped>
.login-hero{
    min-height: 100vh;
    background:
        radial-gradient(60rem 30rem at 85% -10%, rgba(124,92,255,.14), transparent 60%),
        radial-gradient(50rem 26rem at -10% 110%, rgba(16,185,129,.10), transparent 60%),
        #f5f6fb;
    display: flex;
    align-items: center;
    justify-content: center;
}

.login-wrap{ width:100%; display:flex; align-items:center; justify-content:center; padding:3rem }
.login-card{
    max-width: 420px;
    width: 100%;
    border-radius: 18px;
    border: 1px solid #e9ecf5;
    box-shadow: 0 24px 60px -24px rgba(76, 58, 180, .28);
    text-align: left;
    padding: 2.2rem 2.2rem 2rem;
}
.login-card .logo{ display:block; margin: 0 auto .5rem; max-width: 120px; max-height: 90px; object-fit: contain }
.login-card .title{ margin-top: .5rem; margin-bottom: 0; letter-spacing: -.02em; }
.login-sub{
    text-align: center;
    color: #8a90a6;
    font-size: .85rem;
    margin-bottom: 1.4rem;
}

.login-btn{
    width: 100%;
    background: linear-gradient(90deg, #7c5cff, #5b3df0);
    color: #fff;
    border: none;
    border-radius: 11px;
    font-weight: 700;
    height: 2.7rem;
    box-shadow: 0 10px 20px -8px rgba(109,74,255,.55);
    transition: transform .12s ease, box-shadow .15s ease;
}
.login-btn:hover{
    background: linear-gradient(90deg, #6d4aff, #5030e8);
    transform: translateY(-1px);
    box-shadow: 0 14px 24px -8px rgba(109,74,255,.55);
    color: #fff;
}
.login-btn:active{ transform: translateY(0); }

@media (max-width: 768px){
    .login-wrap{ padding: 1rem; }
    .login-card{ margin: 0; padding: 1.6rem 1.4rem; }
    .login-card .logo{ max-width: 100px; max-height: 76px; }
}
</style>